/**
 * @author codex
 * @date 2026.09.02
 * @description 숫자 입력 필드 공통 유틸
 */

/**
 * 숫자 입력 필드에서 마우스 휠로 값이 변경되는 브라우저 기본 동작을 차단한다.
 * 포커스된 상태에서 스크롤할 때 값이 의도치 않게 증감하는 것을 방지한다.
 */
export const preventWheelChange = (
  e: React.WheelEvent<HTMLInputElement>
): void => {
  const target = e.target as HTMLInputElement;
  if (target.type !== 'number') return;
  if (document.activeElement === target) {
    target.blur();
  }
};
